var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/arrow-up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.9170795,15.8615446 L5.2414453,9.18591035 C4.91951823,8.86394974 4.91951823,8.34199651 5.2414453,8.02006944 L6.0200479,7.24146684 C6.3414718,6.92004294 6.86238515,6.91943914 7.18454703,7.24009151 L12.5000168,12.5306377 L17.815453,7.24009151 C18.1376148,6.91943914 18.6585282,6.92004294 18.9799521,7.24146684 L19.7585547,8.02006944 C20.0804818,8.34203005 20.0804818,8.86398328 19.7585547,9.18591035 L13.082954,15.8615446 C12.7609934,16.1834717 12.2390402,16.1834717 11.9170795,15.8615446 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/arrow-up",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "arrow-up",
    fill: "#000000",
    fillRule: "nonzero",
    transform: "translate(12.500000, 11.551495) rotate(180.000000) translate(-12.500000, -11.551495) ",
    xlinkHref: "#path-1"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.76b33d53.svg";
export { ForwardRef as ReactComponent };